import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import AnalyticsProfileSelector from 'app/modules/analytics/components/AnalyticsProfileSelector';
import AnalyticsSidebarGroupProfileList from 'app/modules/analytics/components/AnalyticsSidebarGroupProfileList';
import AnalyticsSidebarLastUsedProfileList from 'app/modules/analytics/components/AnalyticsSidebarLastUsedProfileList';
import AnalyticsSidebarReportTemplates from 'app/modules/analytics/components/AnalyticsSidebarReportTemplates';
import { useAnalyticsSelection } from 'app/modules/analytics/hooks/useAnalyticsSelection';
import { isAnalyticsReportsListRoute } from 'app/modules/analytics/modules/reports/utils/analyticsReportsRoutes';

const AnalyticsSidebar: FC = () => {
  const { pathname } = useLocation();
  const { isGroupSelected } = useAnalyticsSelection();
  const showReportTemplates = isAnalyticsReportsListRoute(pathname);

  return (
    <div className="tw-flex tw-h-full tw-min-h-0 tw-flex-col tw-gap-4 tw-border-r tw-border-solid tw-border-grayscale-20 tw-bg-white tw-p-4">
      <AnalyticsProfileSelector />
      {isGroupSelected ? (
        <AnalyticsSidebarGroupProfileList />
      ) : (
        <AnalyticsSidebarLastUsedProfileList />
      )}
      {showReportTemplates && <AnalyticsSidebarReportTemplates />}
    </div>
  );
};

export default AnalyticsSidebar;
